<div>
  <span [innerHTML]="data.message"></span>
  <button mat-button type="button" (click)="close()">{{ 'ok' | translate }}</button>
</div>
